import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, of } from 'rxjs';
import { StorageService } from 'src/app/_services/storage.service';
import { environment } from 'src/environments/environment';
const { API_URLBLAZE } = environment;

@Injectable({
  providedIn: 'root'
})

export class ScreeningUtilityService {

    constructor(private http: HttpClient, private storageService: StorageService, private router: Router) { }


    //save Activity TImeline
    saveActivityTimeline(activityData: any) {
      const url = `${API_URLBLAZE}/user/screening/activityTime`;
      return this.http.post(url, activityData).pipe(catchError(this.handleError()));
  }

  updateUtilityKycStatusChange(statusChangeRequest:any){
    const url = `${API_URLBLAZE}/user/customer/customerStatusChange`;
    return this.http.post(url, statusChangeRequest).pipe(catchError(this.handleError()));
  }

  getCustomerNameScreeningById(screeningId: string) {
    const url = `${API_URLBLAZE}/user/screening/nameScreeningRemark/`+screeningId;
    return this.http.get(url).pipe(catchError(this.handleError()));
  }

  //save Name Screening Remark
  saveNameScreeningRemark(nameScreeningData: any) {
    const url = `${API_URLBLAZE}/user/screening/nameScreeningRemark`;
    return this.http.post(url, nameScreeningData).pipe(catchError(this.handleError()));
}
      //Update reviewFlag for customer by Mobile Number
      updateReviewFlag(reviewFlag:number,mobileNumber : String) {
        const url = `${API_URLBLAZE}/user/screening/kycScreeningResponse/${reviewFlag}/${mobileNumber}`;
        return this.http.post(url, null).pipe(catchError(this.handleError()));
    }


    //save 
    saveServiceprovider(productData: any) {
        const url = `${API_URLBLAZE}/transaction/service-provider`;
        return this.http.post(url, productData).pipe(catchError(this.handleError()));
    }

    //send request for screening for shufti pro
    sendScreeningRequestShuftiPro(screeningData: any) {
        const url = `${API_URLBLAZE}/user/kyc-screening/screeningUtility/shuftiPro`;
        return this.http.post(url, screeningData).pipe(catchError(this.handleError()));
    }

     //send request for screening for digi
    sendScreeningRequestDigi(screeningData: any) {
        const url = `${API_URLBLAZE}/user/kyc-screening/screeningUtility/digi`;
        return this.http.post(url, screeningData).pipe(catchError(this.handleError()));
    }

    //Get List All
    getUtilityScreeningList(fullName:String,screeningId:String,status:String,page_size:number,page_no:number,dateFrom:String,dateTo:String) {
      var url = "";
      var filter = "";
      if(fullName != "" && fullName !=null){
        filter = filter+`&fullName=${fullName}`
      }
      if(screeningId != "" && screeningId !=null){
        filter = filter+`&screeningId=${screeningId}`
      }
      if(status != "" && status != null){
        filter = filter+`&screeningStatus=${status}`
      }
      if(dateFrom != "" && dateTo!=""){
        filter = filter+`&createdOn=gte%3D${dateFrom}%24lte%3D${dateTo}`
      }
      url = `${API_URLBLAZE}/user/kyc-screening/screeningUtility?page_size=${page_size}&page_no=${page_no}&sort_dir=DESC&sort_column=createdOn`+filter;
      console.log(url);
      return this.http.get(url).pipe(catchError(this.handleError()));
    }

    //Get Utility Response By Screening ID
    getUtilityResponseById(screeningId: string) {
      const url = `${API_URLBLAZE}/user/kyc-screening/screeningUtilityResponse/`+screeningId;
      return this.http.get(url).pipe(catchError(this.handleError()));
    }

    //Get UserType Data
    getUserTypeData(userType: string) {
      const url = `${API_URLBLAZE}/user/kyc-screening/screeningConfig/`+userType;
      return this.http.get(url).pipe(catchError(this.handleError()));
    }

    //Update UserType Data 
    updateUserTypeData(userTypeData: any) {
      const url = `${API_URLBLAZE}/user/kyc-screening/screeningConfig`;
      return this.http.post(url, userTypeData).pipe(catchError(this.handleError()));
  }

     //Get Utility Response By Screening ID
     getUtilityActivityResponseById(screeningId: string) {
        const url = `${API_URLBLAZE}/user/screening/activityTime/`+screeningId;
        return this.http.get(url).pipe(catchError(this.handleError()));
      }

      //Get Merchant Questions
     getMerchantQuestionList(userType: string) {
      const url = `${API_URLBLAZE}/user/merchant/getQuestion?userType=${userType}`;
      return this.http.get(url).pipe(catchError(this.handleError()));
    }


     //Get Utility PDF Screening Report By Screening ID
    getUtilityPdfById(screeningId:any) {
      return this.http
        .get(
          `${API_URLBLAZE}/user/customer/screeningPdfReport/${screeningId}`,{
            observe:'response',
            responseType: 'blob'
          }
        );
    }
  
      private handleError<T>(operation = 'operation', result?: T) {
        return (error: HttpErrorResponse): Observable<T> => {
          if (error.status == 401) {
            this.storageService.clean()
            this.router.navigate(['/auth/login']);
          }
          result = error?.error;
          return of(result as T);
        };
      }
}